import { render, staticRenderFns } from "./ConfirmUnfollow.vue?vue&type=template&id=22e5d5a7&scoped=true&"
import script from "./ConfirmUnfollow.vue?vue&type=script&lang=js&"
export * from "./ConfirmUnfollow.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmUnfollow.vue?vue&type=style&index=0&id=22e5d5a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e5d5a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/gate/releases/20261022070252/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e5d5a7')) {
      api.createRecord('22e5d5a7', component.options)
    } else {
      api.reload('22e5d5a7', component.options)
    }
    module.hot.accept("./ConfirmUnfollow.vue?vue&type=template&id=22e5d5a7&scoped=true&", function () {
      api.rerender('22e5d5a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/ConfirmUnfollow.vue"
export default component.exports